interface JobActivitySignal {
  activity_status?: string | null;
  activity_checked_at?: string | null;
}

interface JobPayProvenance {
  pay_provenance?: string | null;
}

/** Fail closed to import-time copy when the activity signal is incomplete. */
export const getOpenActivityCheckedAt = (job: JobActivitySignal): string | null => {
  if (job.activity_status !== 'open_verified' || typeof job.activity_checked_at !== 'string') {
    return null;
  }

  const checkedAt = job.activity_checked_at.trim();
  return checkedAt && Number.isFinite(new Date(checkedAt).getTime()) ? checkedAt : null;
};

export const hasEmployerPublishedPay = (job: JobPayProvenance): boolean => (
  job.pay_provenance === 'employer_ats'
);
